<template>
  <div class="link-list">
    <Action-panel :isReady="isPageReady">
      <Button-base
        :type="2"
        :text="translations.labels.button_add_link"
        :hoverInfo="translations.labels.button_add_link_hover"
        :onClick="newItem"
      />
    </Action-panel>
    <TableList :is-ready="isPageReady" :headers="headers" :items="list">
      <template v-slot:item.icon="{ item }">
        <div>
          <img
            class="icon"
            :src="buildImagePath(item)"
            v-if="item.icon && item.icon !== '/Links/'"
          />
          <span v-else>---</span>
        </div>
      </template>
    </TableList>
  </div>
</template>

<script>
import Vue from "vue";
import ActionPanel from "@/components/panel/ActionPanel";
import InnerPanel from "@/components/panel/InnerPanel";
import TablePanel from "@/components/panel/TablePanel";
import ButtonBase from "@/components/dom/ButtonBase";
import SvgIcon from "@/components/dom/SvgIcon";
import Round from "@/components/dom/Round";
import TableList from "@/components/table/TableList";
import Component from "vue-class-component";

@Component({
  components: {
    ActionPanel,
    InnerPanel,
    TablePanel,
    ButtonBase,
    SvgIcon,
    Round,
    TableList,
  },
  inject: {
    imageService: "imageService",
    linkService: "linkService",
  },
})
export default class Link_List extends Vue {
  isPageReady = false;
  search = "";
  list = [];
  get translations() {
    return this.$store.state.translationsStore.currentLang;
  }
  get headers() {
    return [
      {
        text: this.translations.labels.link_table_type,
        value: "type",
      },
      {
        text: this.translations.labels.link_table_to,
        value: "to",
        type: "custom",
        itemValue: (item) => {
          return item.toCode != undefined ? item.toCode : item.externalLink;
        },
      },
      {
        text: this.translations.labels.link_table_subType,
        value: "subType",
      },
      {
        text: this.translations.labels.link_table_width,
        value: "width",
      },
      {
        text: this.translations.labels.link_table_height,
        value: "height",
      },
      {
        text: this.translations.labels.link_table_x,
        value: "x",
      },
      {
        text: this.translations.labels.link_table_y,
        value: "y",
      },
      {
        text: this.translations.labels.link_table_openInNewTab,
        value: "openInNewTab",
        type: "boolean",
        itemValue: (item) => {
          return item.openInNewTab;
        },
      },
      {
        text: this.translations.labels.link_table_hotspot,
        value: "hotspotEnabled",
        type: "boolean",
        itemValue: (item) => {
          return item.hotspotEnabled;
        },
      },
      {
        text: this.translations.labels.link_table_icon,
        value: "icon",
        type: "image",
        itemValue: (item) => {
          return this.buildImagePath(item);
        },
        isVisible: (item) => {
          item.icon && item.icon !== "/Links/";
        },
      },
      {
        text: this.translations.labels.table_edit,
        value: "edit",
        type: "link",
        formatValue: (item) => {
          return `/link/edit/${item.id}/${this.$route.params.id}/${this.$route.params.entityType}`;
        },
        icon: "mdi-pencil",
        buttonType: 2,
      },
      {
        text: this.translations.labels.table_delete,
        value: "delete",
        type: "action",
        icon: "mdi-delete",
        onAction: (item) => {
          this.del(item.id);
        },
      },
    ];
  }
  newItem() {
    this.$router.push(`/link/new/${this.$route.params.id}/${this.$route.params.entityType}`);
  }
  async del(_itemId) {
      const confirm = window.confirm(this.translations.confirmDialog.message);
      if (confirm) {
        this.isPageReady = false;
        await this.linkService.delete(_itemId);
        this.getList();
      }
  }
  buildImagePath(item) {
    let output = item?.iconPublicUrl ?? this.imageService.getImagePath(item.icon);
    return output;
  }
  created() {
    this.$store.commit(
      "SET_SECTION_TITLE",
      this.translations.pageTitles.link_list
    );
  }

  async getList() {
    this.list = await this.linkService.list(this.$route.params.id);
    this.isPageReady = true;
  }

  mounted() {
    this.getList();
  }
}
</script>
<style lang="scss">
.link-list {
  .btn-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 20px 30px 0 30px;
    margin: 15px 30px 0 30px;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: #2196f3;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .icon {
    width: 100px;
    height: 100px;
    object-fit: cover;
  }

  .place-holder {
    font-size: 1.9rem;
    text-transform: uppercase;
    color: #000000;
    padding: 40px 0;
  }

  .round-component {
    cursor: pointer;
  }

  &__button {
    width: 40px;
    height: 40px;
  }
}
</style>
